import { STATUS_LABELS } from "@/lib/format";

const STYLES = {
  confirmed: "bg-[#0B1F3A]/8 text-[#0B1F3A] border-[#0B1F3A]/15",
  rescheduled: "bg-[#C7A76C]/15 text-[#7A5F2E] border-[#C7A76C]/40",
  completed: "bg-emerald-50 text-emerald-800 border-emerald-200",
  cancelled: "bg-slate-100 text-slate-500 border-slate-200",
};

export function StatusBadge({ status }) {
  return (
    <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium ${STYLES[status]}`} data-testid={`status-badge-${status}`}>
      {STATUS_LABELS[status]}
    </span>
  );
}

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-bold text-[#0B1F3A]">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-[#697386]">{subtitle}</p>}
      </div>
      {children}
    </div>
  );
}
